// C:\Users\aleja\Code\inventory_analytics\src\front\src\utils\navigation.js

export const NAVIGATION = [
  {
    key: "home",
    label: "Inicio",
    icon: "bi-house-door",
    to: "/",
  },
  {
    key: "panel",
    label: "Panel",
    icon: "bi-speedometer2",
    to: "/panel",
    requiresAuth: true,
    roles: ["admin", "tecnico"],
  },
  {
    key: "pending-part-exits",
    label: "Escaneo repuestos",
    icon: "bi-clipboard-check",
    to: "/pending-part-exits",
    requiresAuth: true,
    roles: ["admin", "tecnico", "scanner"],
  },
];

export const NAVIGATION_GROUPS = [
  {
    key: "warehouse",
    label: "Almacén",
    icon: "bi-box-seam",
    items: [
      {
        key: "warehouse-import",
        label: "Importar Excel",
        icon: "bi-file-earmark-arrow-up",
        to: "/imports/warehouse-excel",
        requiresAuth: true,
        roles: ["admin"],
      },
      {
        key: "import-batches",
        label: "Lotes importados",
        icon: "bi-collection",
        to: "/import-batches",
        requiresAuth: true,
        roles: ["admin", "tecnico"],
      },
      {
        key: "add-inventory-data",
        label: "Añadir datos manuales",
        icon: "bi-pencil-square",
        to: "/add-inventory-data",
        requiresAuth: true,
        roles: ["admin"],
      },
    ],
  },
  {
    key: "catalog",
    label: "Catálogo",
    icon: "bi-tags",
    items: [
      {
        key: "suppliers-catalog",
        label: "Proveedores",
        icon: "bi-buildings",
        to: "/suppliers-catalog",
        requiresAuth: true,
        roles: ["admin", "tecnico"],
      },
      {
        key: "machines",
        label: "Máquinas",
        icon: "bi-gear-wide-connected",
        to: "/machines",
        requiresAuth: true,
        roles: ["admin", "tecnico"],
      },
      {
        key: "parts-catalog",
        label: "Repuestos",
        icon: "bi-nut",
        to: "/parts-catalog",
        requiresAuth: true,
        roles: ["admin", "tecnico"],
      },
      {
        key: "orma-catalog",
        label: "Catálogo ORMA",
        icon: "bi-search",
        to: "/orma-catalog",
        requiresAuth: true,
        roles: ["admin", "tecnico"],
      },
      {
        key: "orma-catalog-admin",
        label: "Administración ORMA",
        icon: "bi-database-gear",
        to: "/orma-catalog/admin",
        requiresAuth: true,
        roles: ["admin"],
      },
    ],
  },
  {
    key: "analytics",
    label: "Analítica",
    icon: "bi-graph-up-arrow",
    items: [
      {
        key: "warehouse-cost-analytics",
        label: "Coste almacén",
        icon: "bi-currency-euro",
        to: "/warehouse-cost-analytics",
        requiresAuth: true,
        roles: ["admin"],
      },
      {
        key: "orma-valuation",
        label: "Valoración de almacenes",
        icon: "bi-currency-euro",
        to: "/orma-valuation",
        requiresAuth: true,
        roles: ["admin", "tecnico"],
      },
    ],
  },
  {
    key: "administration",
    label: "Administración",
    icon: "bi-gear",
    items: [
      {
        key: "users",
        label: "Usuarios",
        icon: "bi-people",
        to: "/users",
        requiresAuth: true,
        roles: ["admin"],
      },
      {
        key: "user-activity",
        label: "Actividad usuarios",
        icon: "bi-clock-history",
        to: "/user-activity",
        requiresAuth: true,
        roles: ["admin"],
      },
      {
        key: "user-activity-analytics",
        label: "Analítica actividad",
        icon: "bi-activity",
        to: "/user-activity-analytics",
        requiresAuth: true,
        roles: ["admin"],
      },
    ],
  },
  {
    key: "repair-management",
    label: "GESTIÓN OPERATIVA",
    roles: ["admin", "tecnico"],
    items: [
      {
        to: "/reparable-spare-parts",
        label: "Repuestos en reparación",
        icon: "bi-tools",
        roles: ["admin", "tecnico"],
      },
      {
        key: "repairable-spare-parts-deleted",
        to: "/reparable-spare-parts/deleted",
        label: "Historial de eliminados",
        icon: "bi-trash3",
        requiresAuth: true,
        roles: ["admin"],
      },
    ],
  },
];

const canAccessNavigationItem = (item, { isAuthenticated, role }) => {
  if (item.requiresAuth && !isAuthenticated) return false;

  if (Array.isArray(item.hiddenForRoles) && item.hiddenForRoles.includes(role)) {
    return false;
  }

  if (Array.isArray(item.roles) && item.roles.length > 0) {
    return item.roles.includes(role);
  }

  return true;
};

export const getVisibleNavigation = ({ isAuthenticated, role }) => ({
  links: NAVIGATION.filter((item) =>
    canAccessNavigationItem(item, { isAuthenticated, role }),
  ),
  groups: NAVIGATION_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) =>
      canAccessNavigationItem(item, { isAuthenticated, role }),
    ),
  })).filter((group) => group.items.length > 0),
});
